export const UPDATE_STATEMENT_TEMPLATE_SUCCESS = 'UPDATE_STATEMENT_TEMPLATE_SUCCESS';

export const updateStatementTemplateSuccess = ({ statementTemplate }) => ({
    type: UPDATE_STATEMENT_TEMPLATE_SUCCESS,
    payload: {
        statementTemplate,
    },
});
